<template>
  <container title="Emissão de GR-PR">
    <div>
    </div>
    <EmitirGuiaForm />
  </container>
</template>

<script>
import EmitirGuiaForm from './components/EmitirGuiaForm.vue'
export default {
  components: {
    EmitirGuiaForm
  },
  data () {
    return {
      reCaptchaKey: window.location.hostname.includes("arrecadacao.fazenda.pr.gov.br") || window.location.hostname.includes("emitirgrpr.sefa.pr.gov.br") ? '6LeuzLspAAAAAF0LbB_B8eW66gTwxfTgpm7-_6IQ' : '6LeYVhEnAAAAAKwXThPK728k_3meLp564_xRkApM',
    }
  },
  computed: {
    isAutenticado() {
      return this.$route.meta.requiresAuth
    }    
  },
  mounted() {
    // reCAPTCHA Enterprise
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${this.reCaptchaKey}`;
    if(!this.isAutenticado)
      document.body.appendChild(script);
  },
}
</script>

<style></style>